import { render, staticRenderFns } from "./DeliverView.vue?vue&type=template&id=1172646e&"
import script from "./DeliverView.vue?vue&type=script&lang=js&"
export * from "./DeliverView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports